/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */
var IO = new Class({
    Implements:[NaturalDelay],
    in:function(direct){
        this.element = $(this.data.eid);
        this.attach(direct);
        this.attachRedo();

        if(!direct){
            if(this.element){
                var isQuestion = typeof this.data.type === 'object';
                setTimeout(function(){
                    this.element.removeClass('isLoading');
                    if(this.data.type == 'answer'){
                        setTimeout(function(){
                            this.renderCallback(this.data, this.data.eid, true);
                        }.bind(this),this.getNaturalDelay('short'));
                    }
                    var viewDelay = isQuestion ? 0 : 300;
                    setTimeout(function(){
                        this.viewCallback(this.data.eid, false);
                    }.bind(this), viewDelay);
                }.bind(this),50);
                var finish = function() {
                    if(this.data.type !== 'answer' && !this.data.redo){
                        this.renderCallback(this.data, this.data.eid, true);
                    }
                    this.element.addClass('isComplete');
                    this.element.addClass('isCold');
                }.bind(this)
                if(isQuestion){
                    finish()
                } else {
                    setTimeout(function(){
                        this.element.addClass('isComplete');
                        setTimeout(finish, this.getNaturalDelay());
                    }.bind(this),this.getNaturalDelay('progress'));
                }
            }
        }
    },
    out:function(){
        var args = (this.out.arguments.length)? this.out.arguments : false;
        this.element.setStyles({'opacity' : 0 });

        setTimeout(function(){
            this.element.destroy();
            if(args){
                if(args.length > 1){
                    args.each(function(element, i){typeof this.data.type === 'object'
                        element.destroy();
                    }.bind(this));
                }else{
                    args[0].destroy();
                }
            }
        }.bind(this), 0);
    }
});
